import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { Form } from 'semantic-ui-react';
import { TASK_EXECUTION_TYPE } from '../../../../constnats/task';
import {
    ExecutionConfigType,
    TaskExecutionsCreationSchemaType,
    TaskIdType,
    taskExecutionsCreationSchema,
} from '../../../../schemas/task.schemas';
import { CompanyType } from '../../../../types/company.types';
import { getOption } from '../utils';
import { getTaskExecutionCreateFormDefaultState } from './utils';

type TaskExecutionFormPropsType = {
    taskId: TaskIdType;
    onSave: (data: TaskExecutionsCreationSchemaType) => void;
    onCancel: () => void;
    companies: CompanyType[];
};

function TaskExecutionsCreateForm({ taskId, onSave, onCancel, companies }: TaskExecutionFormPropsType) {
    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<TaskExecutionsCreationSchemaType>({
        defaultValues: getTaskExecutionCreateFormDefaultState(taskId),
        resolver: zodResolver(taskExecutionsCreationSchema),
    });

    const onSubmit = handleSubmit((data) => {
        onSave(data);
    });

    return (
        <Form onSubmit={onSubmit}>
            <Controller
                name="entities"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Dropdown
                        value={value.map((executionConfig) => executionConfig.entityId)}
                        onChange={(_, data) => {
                            if (Array.isArray(data.value)) {
                                const newData: ExecutionConfigType[] = data.value.map((companyId) => ({
                                    entityId: Number(companyId),
                                    entityType: TASK_EXECUTION_TYPE.COMPANY,
                                }));
                                onChange(newData);
                            }
                        }}
                        label="Companies"
                        placeholder="Companies"
                        selection
                        search
                        multiple
                        options={companies.map((c) => getOption(c.id, c.name))}
                    />
                )}
            />

            <Form.Group className="flex flex-justify-space-between">
                <Form.Button primary type="submit">
                    Save
                </Form.Button>
                <Form.Button type="button" onClick={onCancel}>
                    Cancel
                </Form.Button>
            </Form.Group>
        </Form>
    );
}

export default TaskExecutionsCreateForm;
